import { useState } from 'react';
import moment from 'moment';
import { useMount } from 'ahooks';
import { fetchUserSearchTrendingStatus } from '@home/services/search';
import { getNullableMoment } from '@intelligence/v3/utils/date';

export type IShowDateValue = 'true' | 'false' | (string & {});

const DEFAULT_KEY = 'market_profile_pc_console_filters_redirect_confirm_interaction_show_date';

export const getIsShowByShowDate = (showDate: IShowDateValue) => {
  if (showDate === 'true') return true;
  if (showDate === 'false') return false;
  const dateM = getNullableMoment(showDate);
  if (!dateM?.isValid()) return false;
  return moment().startOf('date').isSameOrBefore(dateM);
};

export default function useDontShowAgain(key = DEFAULT_KEY) {
  const [showDate, setShowDate] = useState<IShowDateValue>('false');

  const initializeDontShowAgain = async () => {
    const res = await fetchUserSearchTrendingStatus({
      action: 'get',
      keys: [DEFAULT_KEY],
    });

    setShowDate(res?.[key] ?? 'true');
  };

  const updateDontShowAgain = async (payload: IShowDateValue) => {
    await fetchUserSearchTrendingStatus({
      action: 'set',
      key: DEFAULT_KEY,
      value: payload,
    });
    setShowDate(payload);
  };

  useMount(() => {
    initializeDontShowAgain();
  });

  return { showDate, updateDontShowAgain };
}
